import { Box, Table, TableBody } from "@mui/material";
import { useEffect } from "react";

import CSVUploader from "@/components/membership/ChooseFormulaModal/lookupForm/CSVLoader/CSVUploader";
import LookupTableFooter from "@/components/membership/ChooseFormulaModal/lookupForm/LookupTable/LookupTableFooter";
import LookupTableHeader from "@/components/membership/ChooseFormulaModal/lookupForm/LookupTable/LookupTableHeader";
import LookupTableRow from "@/components/membership/ChooseFormulaModal/lookupForm/LookupTable/LookUpTableRow";
import LookupTableUtils from "@/components/membership/ChooseFormulaModal/lookupForm/LookupUtils/LookupTableUtils";

const LookupTable = ({
  lookupColumns,
  updateLookupColumns,
  tableValues,
  updateTableValues,
  permittedOutputs,
  updateErrors,
  alterTable,
  updateFullTable,
}) => {
  const {
    lookupTableContainsDuplicateRows,
    determineIfRowsMatchExceptFinalEntry,
  } = LookupTableUtils();

  useEffect(() => {
    validateTable(tableValues);
    // validateTable is an inline function recreated every render; depending
    // on it would cause infinite re-runs. Only react to tableValues.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableValues]);

  const validateTable = () => {
    if (!tableValues) return;

    const hasDuplicates = lookupTableContainsDuplicateRows(tableValues);
    const hasBlankOutputs = !!tableValues.find(
      (row) => row && row[row.length - 1].trim() === ""
    );
    const hasMultipleRows =
      determineIfRowsMatchExceptFinalEntry(tableValues).length > 0;

    updateErrors("duplicateRows", hasDuplicates);
    updateErrors("blankOutputs", hasBlankOutputs);
    updateErrors("multipleRowsSameOutput", hasMultipleRows);
  };

  return (
    <>
      <Box sx={{ border: "solid #8080804d 1px", borderRadius: "8px" }}>
        <Table data-testid="lookup-formula-input-table">
          <LookupTableHeader
            tableValues={tableValues}
            lookupColumns={lookupColumns}
            updateLookupColumns={updateLookupColumns}
            updateErrors={updateErrors}
          />
          <TableBody>
            {tableValues &&
              tableValues.map((data, index) => {
                return (
                  <LookupTableRow
                    key={`lookup-table-row-${index}`}
                    tableRowIndex={index}
                    data={data}
                    permittedOutputs={permittedOutputs}
                    updateTableValues={updateTableValues}
                    updateErrors={updateErrors}
                  />
                );
              })}
            <LookupTableFooter rows={tableValues} alterTable={alterTable} />
          </TableBody>
        </Table>
      </Box>
      <CSVUploader
        updateLookupColumns={updateLookupColumns}
        updateTableValues={updateTableValues}
        permittedOutputs={permittedOutputs}
        updateFullTable={updateFullTable}
      />
    </>
  );
};

export default LookupTable;
